<script>
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
    ...mapState('assistantWizard', ['channelConfig', 'error']),
    websiteUrl() {
      if (!this.channelConfig.web_widget) {
        return null;
      }

      return this.channelConfig.web_widget.website_url;
    },
  },
  methods: {
    ...mapActions('assistantWizard', ['next', 'updateChannelConfigItem']),
    inputConfigItem(e) {
      this.updateChannelConfigItem({
        channel: 'web_widget',
        item: e.target.name,
        value: e.target.value,
      });
    },
    websiteUrlError() {
      return this.error === 'website_url';
    },
  },
};
</script>

<template>
  <section class="flex items-center flex-col">
    <form
      class="flex flex-col w-full flex-1 mb-8 items-center"
      @submit.prevent="next()"
    >
      <label
        class="text-xl text-center text-slate-900 dark:text-slate-50 mb-8"
        for="website_url"
      >
        {{ $t('ASSISTANT_MGMT.WIZARD.CHANNELS.WEBSITE.WEBSITE_URL_LABEL') }}
      </label>
      <input
        id="website_url"
        :value="websiteUrl"
        class="rounded-md border-2 border-slate-100 text-center p-2 w-80 h-10 leading-10"
        name="website_url"
        @input="inputConfigItem"
      />
      <span v-if="websiteUrlError()" class="message">
        {{ $t('ASSISTANT_MGMT.WIZARD.CHANNELS.WEBSITE.WEBSITE_URL_ERROR') }}
      </span>
    </form>
  </section>
</template>
